import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { faUser, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe, DOCUMENT, NgIf } from '@angular/common';
import {
  NgbCollapse,
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthStateService } from 'src/app/AuthStateService';
import config from 'auth_config.json';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  standalone: true,
  imports: [
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdown,
    NgbCollapse,
    AsyncPipe,
    NgIf,
    RouterLink,
  ],
})
export class NavBarComponent implements OnInit {
  isCollapsed = true;
  faUser = faUser;
  faPowerOff = faPowerOff;

  @Output() dataEmitter = new EventEmitter<boolean>();
  constructor(
    @Inject(AuthService) public auth: AuthService,
    @Inject(DOCUMENT) private doc: Document,
    private route: ActivatedRoute,
    private authStateService: AuthStateService // Inject the AuthStateService
  ) {}

  ngOnInit() {
     this.route.queryParams.subscribe(params => {
      console.log('Query Params:', params);
      // Check for specific parameters that indicate a call from Auth0
      if (!this.authStateService.hasLoginBeenCalled() && (params['connection'] || params['organization'] || params['login_hint'] || params['ext-prompt-screen'])) {
        this.dataEmitter.emit(true);
        this.authStateService.setLoginCalled(true);
        this.loginURL(); // Call loginURL only if relevant parameters are present
      }
    });
  }

  loginWithRedirect() {
    this.auth.loginWithRedirect({
      authorizationParams: {
        redirect_uri: config.appUri,
        scope: 'offline_access openid profile email',
        audience: 'https://ShareservicesAPI',
      },
    });
  }

  loginURL() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const authParams: any = {
      authorizationParams: {
        redirect_uri: config.appUri,
        scope: 'offline_access openid profile email',
        audience: 'https://ShareservicesAPI',
      }
    };

    this.route.queryParams.subscribe(params => {
      if (params['connection']) {
        authParams.authorizationParams.connection = params['connection'];
      }
      if (params['ext-connection']) {
        authParams.authorizationParams['ext-connection'] = params['ext-connection'];
      }
      if (params['Organization_id']) {
        authParams.authorizationParams.organization = params['Organization_id'];
      }
      if (params['organization']) {
        authParams.authorizationParams.organization = params['organization'];
      }
      if (params['Enduserinfo_Id']) {
        authParams.authorizationParams.Enduserinfo_Id = params['Enduserinfo_Id'];
      }
      if (params['login_hint']) {
        authParams.authorizationParams.login_hint = params['login_hint'];
      }
      if (params['screen_hint']) {
        authParams.authorizationParams.screen_hint = params['screen_hint'];
      }
      if (params['ext-prompt-screen']) {
        authParams.authorizationParams.screen_hint = params['ext-prompt-screen'];
      }      
      if (params['invitation']) {
        authParams.authorizationParams.invitation = params['invitation'];
      }
      if (params['organization_name']) {
        authParams.authorizationParams.organization_name = params['organization_name'];
      }
      if (params['InvitationId']) {  
        authParams.authorizationParams['ext-invitationId'] = params['InvitationId'];
      }if (params['organization']) {  
        authParams.authorizationParams['ext-organization_id'] = params['organization'];
      }
    });
    this.auth.loginWithRedirect(authParams);
  }

  signupWithRedirect() {
    this.auth.loginWithRedirect({
      authorizationParams: {
        'ext-prompt-screen': 'signup',
        'screen_hint': 'signup'
        }});
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: config.appUri } });
  }
}
